(() => {
  const drawer = document.querySelector('[data-quick-buy-drawer]');
  const checkout = document.querySelector('[data-quick-buy-checkout]');
  if (!drawer) return;

  const triggers = document.querySelectorAll('[data-quick-buy-open]');
  const radios = drawer.querySelectorAll('input[name="quick-buy-pack"]');
  const quantityInput = drawer.querySelector('[data-quick-buy-quantity]');
  const productImage = drawer.querySelector('[data-quick-buy-product-image]');
  let returnFocus = null;

  const quantity = () => Math.min(99, Math.max(1, Math.trunc(Number(quantityInput?.value) || 1)));

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: window.Shopify?.currency?.active || drawer.dataset.currency || 'USD'
      }).format(cents / 100);
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const updateCheckout = () => {
    const selected = drawer.querySelector('input[name="quick-buy-pack"]:checked');
    if (!selected || !checkout) return;
    const count = quantity();
    checkout.href = `${window.TwoFourSix?.cart || '/cart'}/${selected.value}:${count}`;
    checkout.textContent = `BUY ${selected.dataset.packTitle.toUpperCase()} × ${count} — ${formatMoney(Number(selected.dataset.packPriceCents) * count)}`;
    if (productImage && selected.dataset.packImage) {
      productImage.src = selected.dataset.packImage;
      productImage.alt = `${productImage.dataset.productTitle} ${selected.dataset.packTitle}`;
    }
  };

  const open = (trigger) => {
    window.TwoFourSixCart?.close();
    const currentVariantId = document.querySelector('[data-product-root] [name="id"]')?.value;
    const currentPack = [...radios].find((radio) => radio.value === currentVariantId && !radio.disabled);
    if (currentPack) {
      currentPack.checked = true;
      updateCheckout();
    }
    returnFocus = trigger;
    document.body.classList.add('quick-buy-open');
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    triggers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => drawer.focus({ preventScroll: true }));
  };

  const close = () => {
    if (!document.body.classList.contains('quick-buy-open')) return;
    document.body.classList.remove('quick-buy-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    triggers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    returnFocus?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-buy-open]');
    if (trigger) { open(trigger); return; }
    if (event.target.closest('[data-quick-buy-close]')) { close(); return; }
    const adjust = event.target.closest('[data-quick-buy-adjust]');
    if (adjust && quantityInput) {
      quantityInput.value = String(Math.min(99, Math.max(1, quantity() + Number(adjust.dataset.quickBuyAdjust))));
      updateCheckout();
      return;
    }
    if (event.target.closest('[data-cart-open], #bag-pill')) close();
  });

  drawer.addEventListener('change', (event) => {
    const selected = event.target.closest('input[name="quick-buy-pack"]');
    if (selected?.checked) updateCheckout();
  });

  quantityInput?.addEventListener('input', updateCheckout);
  quantityInput?.addEventListener('change', () => {
    quantityInput.value = String(quantity());
    updateCheckout();
  });

  document.addEventListener('keydown', (event) => {
    if (!document.body.classList.contains('quick-buy-open')) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;

    const focusable = [...drawer.querySelectorAll('button, a[href], input:not(:disabled)')]
      .filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });

  if (radios.length && !drawer.querySelector('input[name="quick-buy-pack"]:checked')) {
    const available = [...radios].find((radio) => !radio.disabled);
    if (available) { available.checked = true; available.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  updateCheckout();
})();
